import FormDataFormatter from "./FormDataFormatter";
import ReactSelectFormatter from "./ReactSelectFormatter";

class CompanyFormSerializer {
    static serialize(formData, categories = []) {

        let transformedKeywords = {
            businessCategories: [],
            keywords: []
        };

        let keywords = formData.keywords || [];
        let keywordsExtra = formData.keywordsExtra || [];
        let businessIds = keywords.map(keyword => {
            let result = categories.find(c => c.name === keyword);
            if (!result) {
                transformedKeywords.keywords.push(keyword)
            }
            return result;
        });
        businessIds = businessIds.filter(b => b);
        transformedKeywords.businessCategories = businessIds.map(b => b.id);

        let data = {...formData};
        data.latitude = data.latitude || '';
        data.longitude = data.longitude || '';
        data.defaultImageId = data.defaultImageIds[0] || '';
        data.image = data.images[0];
        data.portal = formData.portal || 1;
        data.phoneNumber !== null ? data.phoneNumber = this.formatPhone(data.phoneNumber) : data.phoneNumber;
        data.faxNumber !== null ? data.faxNumber = this.formatPhone(data.faxNumber) : data.faxNumber;
        data.keywords = JSON.stringify(transformedKeywords);
        data.keywordsExtra = JSON.stringify(keywordsExtra);
        data.articlesCategories = formData.articlesCategories.map(c => {
            return c.value === undefined ? c : c.value
        }) || [];
        data.specialBusinessCategories = data.specialBusinessCategories.map((businessCategory) => {
            return businessCategory.id;
        });

        data.companyCoverRegionsIds = data.companyCoverRegions.map(region => {
            return region.value;
        });

        let imagesExtraInfo = data.imagesExtra.map((image) => {
            return {
                'imageName' : image.filename,
                'dropzoneId' : 'Extra'
            };
        });
        data.imagesExtraInfo = JSON.stringify(imagesExtraInfo);

        delete data.companyCoverRegions;
        delete data.defaultImages;
        delete data.defaultImageIds;
        delete data.images;

        return FormDataFormatter.getFormData({...data});
    }

    static formatPhone(phone) {
        return phone.toString().replace(/-/g, "");
    }

    static unserialize(response) {

        let portal = '';
        let images = [];
        let defaultImages = [];
        let defaultImageIds = [];

        let facebook = '';
        let linkedin = '';
        let twitter = '';
        let instagram = '';

        if (response.logo && response.logo.id) {
            defaultImages = [response.logo];
            images = [];
            defaultImageIds = [response.logo.id];
        }

        let formattedResponse = {...response};
        if (formattedResponse.imagesExtra instanceof Object) {
            if (!(formattedResponse.imagesExtra instanceof Array)) {
                formattedResponse.imagesExtra = Object.values(formattedResponse.imagesExtra);
            }

            formattedResponse.defaultImagesExtra = formattedResponse.imagesExtra;
            formattedResponse.defaultImageIdsExtra = formattedResponse.defaultImagesExtra.map(image => image.id);
        }
        else {
            formattedResponse.imagesExtra = [];
            formattedResponse.defaultImagesExtra = [];
            formattedResponse.defaultImageIdsExtra = [];
        }

        if (response.portal !== undefined && response.portal.id !== undefined) {
            portal = response.portal.id;
        }

        // FIXME
        response.socials.map(social => {
            switch (social.socialMedia.name) {
                case 'facebook':
                    facebook = social.link;
                    break;
                case 'linkedin':
                    linkedin = social.link;
                    break;
                case 'instagram':
                    instagram = social.link;
                    break;
                case 'twitter':
                    twitter = social.link;
                    break;
            }
        });


        return {
            id: response.id,
            description: response.description,
            keywords: response.keywords || [],
            keywordsExtra: response.keywordsExtra || [],
            companyProfileInformationLoaded: false, // ?????
            countryId: response.location.country !== undefined ? response.location.country.id : 1,
            regionId: response.location.regionId,
            municipalityId: response.location.municipalityId,
            addressId: response.location.addressId,
            addressPreLoaded: false,   // ?????
            latitude: response.location.latitude,
            longitude: response.location.longitude,
            name: response.name,
            city: response.location.city,
            postalCode: response.location.postalCode,
            address: response.location.address,
            cvr: response.cvr,
            pNumber: response.pNumber,
            phoneNumber: response.phoneNumber,
            faxNumber: response.faxNumber,
            email: response.email,
            showOnGoogleMaps: response.showOnGoogleMaps,
            hideAddressEverywhere: response.hideAddressEverywhere,
            homepage: response.homepage,
            facebook,
            linkedin,
            twitter,
            instagram,
            employeeCount: response.employeeCount,
            previewLocation: {}, // ???????
            companyInformationLoaded: false, // ??????
            recruiterId: response.recruiterId,
            images,
            defaultImageIds,
            defaultImages,
            imagesExtra: [],
            defaultImageIdsExtra: formattedResponse.defaultImageIdsExtra,
            defaultImagesExtra: formattedResponse.defaultImagesExtra,
            categoryIds: response.categories.map(category => category.id) || [],
            portal,
            youtubeId: response.youtubeId,
            vimeoId: response.vimeoId,
            keywordsCount: response.keywordsCount,
            articlesCategories: response.articlesCategories || [],
            specialBusinessCategories: response.specialBusinessCategories,
            companyCoverRegions: response.companyCoverRegions? ReactSelectFormatter.format(response.companyCoverRegions) : [],
            companyTaskIds: response.companyTasks ? response.companyTasks.map(task => task.id) : [],
            subscriptionType: response.subscriptionType.toString(),
            dmogeMember: response.dmogeMember,
            showFacebookFeed: response.showFacebookFeed
        };
    }
}

export default CompanyFormSerializer;


// WEBPACK FOOTER //
// ./web/src/services/CompanyFormSerializer.js